<script>
import { required, minValue } from "vuelidate/lib/validators";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Supplier from "@/components/modals/supplier.vue";
import { cloneDeep, groupBy } from "lodash"; // Add lodash import

export default {
    name: "CreateRfpModal",
    components: {
        MaskedInput,
        Supplier,
    },
    props: {
        modalTitle: {
            type: String,
            default: "Create RFP"
        }
    },
    data() {
        return {
            submitted: false,
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
                decimalSymbol: ".",
                allowLeadingZeroes: false,
            }),
            form: {
                particulars: "",
                payee: "",
                payeeAddress: "",
                deliveryUnitBudgetItemId: 0,
                requestTypeId: null,
                amount: '',
            },
            deliveryUnitBudgetItems: [],
            requestTypes: [],
            loadingRequestTypes: false,
            loadingBudgetItems: false,
            // Add BLI Screen variables
            showBLIScreen: false,
            slideBLI: false,
            showBLIBtn: false,
            bliBtn: "",
            budgetData: [],
            groupedBudget: [],
            budgetBusy: false,
            selectedBLI: null,
            filterBudget: "",
            budgetIndex: -1,
        };
    },
    validations: {
        form: {
            particulars: { required },
            payee: { required },
            deliveryUnitBudgetItemId: { required },
            amount: { required },
            requestTypeId: { required }
        },
    },
    computed: {
        filteredBudget() {
            let data = this.groupedBudget;
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterBudget.toUpperCase());
                });
            }
            return data;
        },
        rowsBudget() {
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                return this.filteredBudget.length;
            } else {
                return this.groupedBudget.length;
            }
        },
    },
    methods: {
        onReset() {
            this.form = {
                id: 0,
                particulars: "",
                supplierId: null,
                payee: "",
                deliveryUnitBudgetItemId: null,
                requestTypeId: null,
                amount: '',
            };
            this.$v.$reset();
            this.submitted = false;
        },
        updateData(item) {
            this.form = {
                id: item.id,
                particulars: item.particulars,
                supplierId: item.supplierId,
                payee: item.payee,
                payeeAddress: item.payeeAddress,
                deliveryUnitBudgetItemId: item.deliveryUnitBudgetItemId,
                requestTypeId: item.requestTypeId,
                rfpNumber: item.rfpNumber,
                rfpDate: item.rfpDate,
                amount: this.numberWithCommas(item.amount),
            };
            this.selectedBLI = {
                deliveryUnitBudgetItemId: item.deliveryUnitBudgetItemId,
                accountGroup: item.deliveryUnitBudgetItem,
                balance: item.amount,
            };
        },
        async onSubmit(isPosted = false) {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            const data = {
                ...this.form,
                amount: this.getExactAmt(this.form.amount),
                deliveryUnitBudgetItem: this.selectedBLI
                    ? this.selectedBLI.accountGroup
                    : "",
                isPosted: isPosted
            };
            this.$emit("createRfp", data);
        },
        getSupplier() {
            this.$bvModal.show("supplier-modal");
        },
        dropSupplier(supplier) {
            this.form.supplierId = supplier.id;
            this.form.payee = supplier.name;
        },
        removeSupplier() {
            this.form.supplierId = 0;
            this.form.payee = "";
        },
        updateAmount() {
            if (this.form.deliveryUnitBudgetItemId > 0) {
                const selectedItem = this.deliveryUnitBudgetItems.find(
                    item => item.id == this.form.deliveryUnitBudgetItemId
                );
                if (selectedItem && selectedItem.available) {
                    this.form.amount = selectedItem.available;
                }
            }
        },
        // Add BLI Screen methods
        async selectBudgetItem() {
            this.showBLIScreen = true;
            this.openBLI();
        },
        async getAllBudgets() {
            this.budgetData = [];
            this.budgetBusy = true;
            await this.$store
                .dispatch("officebudgetitem/GetMyOfficeBudgetItemSummary", {
                    cycle: this.$store.state.data.cycle,
                    deliveryUnitId: this.$store.state.data.selectedDU.id,
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    var budgetData = [];
                    res.data.map(item => {
                        item.showData = true;
                        item.filterKey = `${item.fundSource}`;
                        item.fundClassification.map(x => {
                            x.showData = true;
                            item.filterKey += ` ${x.fundClassification}`;
                            x.filterKey = `${item.fundSource} ${x.fundClassification}`;
                            x.accountGroups.map(y => {
                                item.filterKey += ` ${y.accountGroup}`;
                                x.filterKey += ` ${y.accountGroup}`;
                                y.filterKey = `${item.fundSource} ${y.accountGroup} ${x.fundClassification}`;
                                y.showData = true;
                                y.fundSource = item.fundSource;
                                y.fundClass = x.fundClassification;
                                y.goodMin = x.goodMin;
                                y.goodMax = x.goodMax;
                                budgetData.push(y);
                            })
                        })
                    })
                    this.budgetData = budgetData;
                    this.groupedBudget = res.data;
                    this.budgetBusy = false;
                })
                .catch((err) => {
                    this.budgetBusy = false;
                    this.showToast("Error fetching budget data", "error");
                });
        },
        openBLI() {
            this.slideBLI = !this.slideBLI;
            this.bliBtn = `position:fixed;top:${100}px;left:0;`;
            
            if (this.slideBLI) {
                this.showBLIScreen = true;
                setTimeout(() => {
                    this.showBLIBtn = true;
                }, 400);
            } else {
                this.showBLIBtn = false;    
                setTimeout(() => {
                    this.showBLIScreen = false;
                }, 500);
            }
        },
        closeAllOE() {
            this.groupedBudget.forEach((x) => {
                x.showData = false;
            });
        },
        viewItems(row) {
            this.selectedBLI = cloneDeep(row);
            this.form.deliveryUnitBudgetItemId = row.deliveryUnitBudgetItemId;
            this.form.amount = this.numberWithCommas(row.balance);
            this.closeAllOE();
            this.openBLI();
        },
        filteredBudgetChild(info) {
            let data = cloneDeep(info);
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterBudget.toUpperCase());
                });
            }
            return data;
        },
        checkInput(){
            if (this.selectedBLI && parseFloat(this.getExactAmt(this.form.amount)) > parseFloat(this.selectedBLI.balance)) {
                this.form.amount = this.selectedBLI.balance.toString();
            }
        },
        removeBLI(){
            this.selectedBLI = null; 
            this.form.deliveryUnitBudgetItemId = null; 
            this.form.amount = '';
        },
        // Add method to fetch request types
        async getRequestTypes() {
            this.loadingRequestTypes = true;
            try {
                const response = await this.$store.dispatch("requesttype/GetRequestType");
                this.requestTypes = response.data || [];
            } catch (error) {
                this.showToast("Error fetching request types", "error");
                this.requestTypes = [];
            } finally {
                this.loadingRequestTypes = false;
            }
        },
    },
    created() {
        this.getAllBudgets();
        this.getRequestTypes();
    }
};
</script>

<template>
    <b-modal
        id="create-rfp-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <form @submit.prevent="onSubmit(false)" class="needs-validation">
            <div class="mb-3">
                <label for="requestType" class="form-label">Request Type </label>
                <b-form-select
                    id="requestType"
                    v-model="form.requestTypeId"
                    :options="[
                        { value: null, text: 'Select Request Type...' },
                        ...requestTypes.map(type => ({ value: type.id, text: type.type }))
                    ]"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.form.requestTypeId.$error }"
                    :disabled="loadingRequestTypes"
                ></b-form-select>
                <div v-if="submitted && $v.form.requestTypeId.$error" class="invalid-feedback">
                    <span v-if="!$v.form.requestTypeId.required">Request type is required.</span>
                    <span v-if="!$v.form.requestTypeId.minValue">Please select a valid request type.</span>
                </div>
                <small v-if="loadingRequestTypes" class="text-muted">Loading request types...</small>
            </div>
            <div class="mb-3">
                <label for="deliveryUnitBudgetItem" class="form-label">Allotment Charging </label>
                <div 
                    @click="selectBudgetItem" 
                    v-if="!selectedBLI"
                    class="text-center border border-1 py-3 rounded cursor-pointer" 
                    :class="{ 'border-danger is-invalid': submitted && $v.form.deliveryUnitBudgetItemId.$error }"
                >
                    Click here to select Budget Item
                </div>
                <div v-else>
                    <div class="d-flex justify-content-between align-items-center border border-1 p-2 rounded cursor-pointer" 
                    @click="selectBudgetItem" >
                        <div>
                            <h5 class="mb-1 text-green">{{ selectedBLI.accountGroup }}</h5>
                            <p class="text-muted mb-0">
                                {{form.id > 0 ? 'Max Amount': 'Balance'}}: <span class="text-info">{{ formatCurrency(selectedBLI.balance) }}</span>
                            </p>
                        </div>
                        <div>
                            <button 
                                type="button" 
                                class="btn btn-sm btn-outline-danger"
                                @click.stop="removeBLI()"
                            >
                                <i class="mdi mdi-close-thick"></i> Remove
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="submitted && $v.form.deliveryUnitBudgetItemId.$error" class="invalid-feedback">
                    <span v-if="!$v.form.deliveryUnitBudgetItemId.required">Budget item is required.</span>
                    <span v-if="!$v.form.deliveryUnitBudgetItemId.minValue">Please select a valid budget item.</span>
                </div>
                <small v-if="loadingBudgetItems" class="text-muted">Loading budget items...</small>
            </div>
            <div class="mb-3">
                <label for="payee" class="form-label">Payee </label>
                <!-- <b-input-group> -->
                    <input
                        autocomplete="off"
                        type="text"
                        placeholder="Enter Payee..."
                        class="form-control"
                        :class="{ 'is-invalid': submitted && ($v.form.payee.$error) }"
                        v-model="form.payee"
                    />
                <!-- </b-input-group> -->
                <div v-if="submitted && $v.form.payee.$error" class="invalid-feedback">
                    <span v-if="!$v.form.payee.required">Supplier is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="payeeAddress" class="form-label">Payee Address </label>
                <textarea
                    id="payeeAddress"
                    v-model="form.payeeAddress"
                    placeholder="Enter payee address..."
                    rows="2"
                    class="form-control"
                ></textarea>
            </div>
            <div class="mb-3">
                <label for="particulars" class="form-label">Particulars </label>
                <textarea
                    id="particulars"
                    v-model="form.particulars"
                    placeholder="Enter particulars..."
                    rows="3"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.form.particulars.$error }"
                ></textarea>
                <div v-if="submitted && $v.form.particulars.$error" class="invalid-feedback">
                    <span v-if="!$v.form.particulars.required">Particulars is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="amount" class="form-label">Amount</label>
                <masked-input
                    id="amount"
                    v-model="form.amount"
                    :mask="currencyMask"
                    placeholder="0.00"
                    class="form-control"
                    @input="checkInput"
                    :class="{ 'is-invalid': submitted && $v.form.amount.$error }"
                />
                <div v-if="submitted && $v.form.amount.$error" class="invalid-feedback">
                    <span v-if="!$v.form.amount.required">Amount is required.</span>
                    <span v-if="!$v.form.amount.minValue">Amount must be greater than 0.</span>
                </div>
            </div>

            <div class="modal-footer">
                <b-dropdown
                    id="dropdown-dropleft"
                    right
                    variant="link"
                    toggle-class="text-decoration-none"
                    menu-class="dropdown-menu-end"
                    no-caret
                    v-if="form.id == 0"
                >
                    <template #button-content>
                        <button type="button" class="btn btn-primary">
                            <i class="bx bx-save me-1"></i>
                            Save
                        </button>
                    </template>
                    <b-dropdown-item
                        @click="onSubmit(false)"
                        ><i class="bx bx-receipt me-1"></i> Save As Draft</b-dropdown-item
                    >
                    <b-dropdown-item
                        @click="onSubmit(true)"
                        ><i class="bx bx-check me-1"></i> Save &amp; Post</b-dropdown-item
                    >
                </b-dropdown>
                <button 
                    type="button" 
                    class="btn btn-primary" 
                    v-else 
                    @click="onSubmit(false)"
                >
                    <i class="bx bx-save me-1"></i>
                    Update
                </button>
                <button 
                    type="button" 
                    class="btn btn-link" 
                    @click="$bvModal.hide('create-rfp-modal')"
                >
                    Cancel
                </button>
            </div>
        </form>

        <!-- Supplier Modal -->
        <supplier @dropData="dropSupplier($event)"></supplier>
        <div class="position-fixed" :class="{'bli-option': showBLIScreen}">
            <div class="slide-option" :class="{ active: slideBLI }">
                <a
                    href="javascript:void(0);"
                    @click="openBLI"
                    :style="bliBtn"
                    v-if="showBLIBtn"
                >
                    <i class="bx bx-caret-right font-size-24 py-3 px-2 rounded bg-secondary bg-soft text-white"></i>
                </a>
                <div class="p-5" style="overflow-y: auto; height: 100vh">
                    <b-row>
                        <b-col sm="6" class="d-flex align-items-center">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0">List of Budget Line Items</h4>
                            </div>
                        </b-col>
                        <div class="col-md-6 text-right">
                            <div class="d-flex float-end">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter me-1"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filterBudget"
                                            type="search"
                                            placeholder="Search Budget..."
                                            class="form-control"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </b-row>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <div class="table-responsive">
                                    <table
                                        class="
                                            table table-centered
                                            align-middle
                                            project-list-table
                                            border-collapse-none
                                        "
                                    >
                                        <thead>
                                            <tr>
                                                <th
                                                    scope="col"
                                                    width="50px"
                                                ></th>
                                                <th scope="col">
                                                    Account Name
                                                </th>
                                                <th scope="col" width="200px">
                                                    Budget Allocated
                                                </th>
                                                <th scope="col" width="200px">
                                                    Total Consumed
                                                </th>
                                                <th scope="col" width="200px">
                                                    Balance
                                                </th>
                                                <th
                                                    scope="col"
                                                    width="150px"
                                                    class="text-center"
                                                >
                                                    Expiry
                                                </th>
                                                <th
                                                    scope="col"
                                                    width="150px"
                                                    class="text-center"
                                                >
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="budgetBusy">
                                                <td colspan="7">
                                                    <div
                                                        class="
                                                            d-flex
                                                            justify-content-center
                                                            align-items-center
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                preloader-component
                                                                me-2
                                                            "
                                                        >
                                                            <div class="status">
                                                                <div
                                                                    class="
                                                                        spinner-chase
                                                                        w-20px
                                                                        h-20px
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <strong
                                                            >Loading...</strong
                                                        >
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr
                                                v-if="
                                                    budgetData.length == 0 &&
                                                    !budgetBusy
                                                "
                                            >
                                                <td
                                                    colspan="7"
                                                    class="
                                                        text-muted text-center
                                                    "
                                                >
                                                    <i
                                                        class="
                                                            dripicons-warning
                                                            me-1
                                                        "
                                                    ></i
                                                    >No data found
                                                </td>
                                            </tr>
                                            <tr
                                                v-if="
                                                    filteredBudget.length ==
                                                        0 &&
                                                    filterBudget &&
                                                    !budgetBusy
                                                "
                                            >
                                                <td
                                                    colspan="7"
                                                    class="
                                                        text-muted text-center
                                                    "
                                                >
                                                    <i
                                                        class="
                                                            dripicons-warning
                                                            me-1
                                                        "
                                                    ></i
                                                    >Search not found
                                                </td>
                                            </tr>
                                             <template v-for="(y, yIndex) in filteredBudget">
                                                <tr :key="'A' + y.fundSourceId" style="background-color: transparent; box-shadow: none;">
                                                    <td colspan="2" class="pad-2rem">
                                                        <div class="d-flex align-item-center cursor-pointer" @click="y.showData = !y.showData">
                                                            <span class="bx text-warning me-1"
                                                                :class="{
                                                                    'bx-plus':
                                                                        !y.showData,
                                                                    'bx-minus':
                                                                        y.showData,
                                                                }"
                                                                style="
                                                                    line-height: unset;
                                                                "
                                                            ></span>
                                                            <h5
                                                                class="
                                                                    text-dark
                                                                    mb-0
                                                                "
                                                            >
                                                                {{ y.fundSource }}
                                                            </h5>
                                                        </div>
                                                    </td>
                                                    <td class="py-2">
                                                        <h5 class="text-dark mb-0">
                                                            {{ formatCurrency(y.allocated) }}
                                                        </h5>
                                                    </td>
                                                    <td class="py-2">
                                                        <h5 class="text-dark mb-0">
                                                            {{ formatCurrency(y.totalResources) }}
                                                        </h5>
                                                    </td>
                                                    <td class="py-0">
                                                        <h5 class="text-dark mb-0">
                                                            {{ formatCurrency(y.balance) }}
                                                        </h5>
                                                    </td>
                                                    <td class="py-0"></td>
                                                    <td class="py-0"></td>
                                                </tr>
                                                <template v-if="y.showData">
                                                    <template  v-for="(z, zIndex) in filteredBudgetChild(y.fundClassification)">
                                                        <tr class="classic-tr" :key="`B${y.fundSourceId}-${z.fundClassification.toLowerCase()}`">
                                                            <td colspan="7" class="pad-2rem-5px position-relative">
                                                                <div class="line-vertical-middle"></div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            line-horizontal-middle
                                                                            w-20px
                                                                        "
                                                                    ></div>
                                                                    <b
                                                                        class="
                                                                            text-dark
                                                                        "
                                                                        >{{
                                                                            z.fundClassification
                                                                        }}</b
                                                                    >
                                                                </div>
                                                            </td>
                                                        </tr>
                                                            <tr
                                                                v-for="(x, xIndex) in filteredBudgetChild(z.accountGroups)"
                                                                :key="`y${yIndex}z${zIndex}x${xIndex}`"
                                                                class="classic-tr custom-border-2"
                                                            >
                                                                <td class="pl-5px  position-relative">
                                                                    <div
                                                                        class="line-vertical-middle"
                                                                        :class="{
                                                                            'bottom-50':
                                                                                filteredBudgetChild(y.fundClassification).length -  1 == zIndex &&
                                                                                filteredBudgetChild(z.accountGroups).length - 1 == xIndex
                                                                        }"
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            d-flex
                                                                            align-items-center
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                line-horizontal-middle
                                                                                w-100
                                                                            "
                                                                        ></div>
                                                                    </div>
                                                                </td>
                                                                <td
                                                                    class="
                                                                        bg-table-tr
                                                                    "
                                                                    :class="{
                                                                        'border-top-white':
                                                                            xIndex >
                                                                            0,
                                                                    }"
                                                                >
                                                                    <h5
                                                                        class="
                                                                            text-truncate
                                                                            font-size-14
                                                                            mb-0
                                                                            d-flex
                                                                        "
                                                                    >
                                                                        <a
                                                                            href="javascript: void(0);"
                                                                            class="
                                                                                text-dark
                                                                            "
                                                                            @click="
                                                                                viewItems(
                                                                                    x
                                                                                )
                                                                            "
                                                                            >{{
                                                                                x.accountGroup
                                                                            }}</a
                                                                        >
                                                                    </h5>
                                                                </td>
                                                                <td
                                                                    class="
                                                                        bg-table-tr
                                                                    "
                                                                    :class="{
                                                                        'border-top-white':
                                                                            xIndex >
                                                                            0,
                                                                    }"
                                                                >
                                                                    {{
                                                                        formatCurrency(
                                                                            x.allocated
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="
                                                                        bg-table-tr
                                                                    "
                                                                    :class="{'border-top-white': xIndex != 0}"
                                                                >
                                                                    {{
                                                                        formatCurrency(
                                                                            x.totalResources
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="
                                                                        bg-table-tr
                                                                    "
                                                                    :class="{'border-top-white': xIndex != 0}"
                                                                >
                                                                    {{
                                                                        formatCurrency(
                                                                            x.balance
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="bg-table-tr text-center"
                                                                    :class="{'border-top-white': xIndex != 0 }"
                                                                >
                                                                </td>
                                                                <td
                                                                    class="text-center bg-table-tr"
                                                                    :class="{'border-top-white': xIndex != 0 }"
                                                                >
                                                                    <div
                                                                        class="
                                                                            d-flex
                                                                            justify-content-center
                                                                        "
                                                                    >
                                                                        <a
                                                                            href="javascript:void(0)"
                                                                            @click="viewItems(x)"
                                                                            class="d-flex align-items-center"
                                                                        >
                                                                            <span :class="{'text-success': selectedBLI && selectedBLI.accountGroupId == x.id}">
                                                                                {{ !selectedBLI || selectedBLI.accountGroupId != x.id ? "Select LIB" : "Selected" }}
                                                                            </span>
                                                                            <i 
                                                                                v-if="!selectedBLI || selectedBLI.accountGroupId != x.id"
                                                                                class="fas fa-hand-point-left pointing-animation text-white font-size-18 text-primary cursor-pointer"
                                                                            >
                                                                            </i>
                                                                        </a>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        <!-- </template> -->
                                                    </template>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>